import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'sigv-content-dialog',
  templateUrl: './content-dialog.component.html',
  styleUrls: ['./content-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentDialogComponent extends Dialog implements OnInit {
  @Input() dialogSize: 'small' | 'medium' | 'large' = 'medium';
  @Input() showCancel = true;
  @Input() showConfirm = true;
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() confirm: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    el: ElementRef,
    renderer: Renderer2,
    zone: NgZone,
    cd: ChangeDetectorRef
  ) {
    super(el, renderer, zone, cd);
  }

  ngOnInit(): void {}

  showDialog(event: any): void {
    this._visible = true;
    this.visibleChange.emit(true);
  }

  hideDialog(event: any): void {
    this._visible = false;
    this.visibleChange.emit(false);
  }

  cancelBtnClick(event: any): void {
    this.visible = false;
    this.cancel.emit({ originEvent: event });
  }

  confirmBtnClick(event: any): void {
    this.confirm.emit({ originEvent: event });
  }
}
